import { render, staticRenderFns } from "./imageViewpoint.vue?vue&type=template&id=0a4571d0&scoped=true&"
import script from "./imageViewpoint.vue?vue&type=script&lang=js&"
export * from "./imageViewpoint.vue?vue&type=script&lang=js&"
import style0 from "./imageViewpoint.vue?vue&type=style&index=0&id=0a4571d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4571d0",
  null
  
)

export default component.exports